// Module
var code = "<div class=\"ToolBarPreview\"> <div data-bind=\"attr: { title: Label }\" class=\"control-preview-container\"> <i class=\"fa fa-dot-circle-o\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </div> </div>";
// Exports
export default code;